<app-banner></app-banner>

<section class="page-section">
  <app-numbers />
</section>

<section class="page-section">
  <app-innovation-pillars />
</section>

<section class="page-section">
  <app-first />
</section>

<section scroll-target="courses-section" class="page-section">
  <app-courses-section />
</section>

<section class="page-section">
  <app-mentorship-banner />
</section>

<section class="page-section">
  <app-reviews />
</section>

<section class="page-section">
  <app-blog-posts />
</section>

<section class="page-section">
  <app-community />
</section>
